// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: Z04HmuxDcb7
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Checkbox3 from "../../Checkbox3"; // plasmic-import: YObM5SxsQhe/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingReviewBiz.module.css"; // plasmic-import: Z04HmuxDcb7/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingReviewBiz__VariantProps = new Array();

export const PlasmicOnboardingReviewBiz__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingReviewBiz__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "freeCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "starterCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "premiumCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "growthCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__bq67Q)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__u43Dn
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__fqeD)}>
            <div className={classNames(projectcss.all, sty.freeBox__gAxxu)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__tfOs)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__eTaN7)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__yNwA9)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__dm1V)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__ivUfe)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___3V85)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__iumzb)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__kTP8)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__jZLq)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___9YuRx)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__s7Hkw)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__gUdQ)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__bZM)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mr8HR
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__m955J
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__cXxdp
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mJmqR
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fyvw4
                )}
              >
                {"Confirm & Submit"}
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div
                data-plasmic-name={"title12"}
                data-plasmic-override={overrides.title12}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title12
                )}
              >
                {"Confirm your plan type"}
              </div>
              <div
                data-plasmic-name={"title13"}
                data-plasmic-override={overrides.title13}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title13
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {
                      "Choose between a free plan with low transaction fees or a paid subscription with 0% transaction fees. You may switch your plan at any time and won't be charged until your account has been successfully approved for payments. "
                    }
                  </React.Fragment>
                  {
                    <a
                      data-plasmic-name={"link"}
                      data-plasmic-override={overrides.link}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link
                      )}
                      href={"https://astrius.co/pricing"}
                      target={"_blank"}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{
                            color: "#3555FF",
                            textDecorationLine: "underline"
                          }}
                        >
                          {"Learn More"}
                        </span>
                      </React.Fragment>
                    </a>
                  }

                  <React.Fragment>{""}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ color: "#3555FF" }}
                  >
                    {" "}
                  </span>
                </React.Fragment>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___8X2Kg)}>
                <Checkbox3
                  data-plasmic-name={"freeCheck"}
                  data-plasmic-override={overrides.freeCheck}
                  className={classNames("__wab_instance", sty.freeCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "freeCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "freeCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title8"}
                  data-plasmic-override={overrides.title8}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title8
                  )}
                >
                  {"Free Plan ($0/month) - No Transaction Limit"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__mUypi)}>
                <Checkbox3
                  data-plasmic-name={"starterCheck"}
                  data-plasmic-override={overrides.starterCheck}
                  className={classNames("__wab_instance", sty.starterCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "starterCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "starterCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title9"}
                  data-plasmic-override={overrides.title9}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title9
                  )}
                >
                  {"Starter Plan ($29/month) - Process up to $7,500/month"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__gqSjq)}>
                <Checkbox3
                  data-plasmic-name={"premiumCheck"}
                  data-plasmic-override={overrides.premiumCheck}
                  className={classNames("__wab_instance", sty.premiumCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "premiumCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "premiumCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title10"}
                  data-plasmic-override={overrides.title10}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title10
                  )}
                >
                  {"Premium Plan ($49/month) - Process up to $15,000/month"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__deeYj)}>
                <Checkbox3
                  data-plasmic-name={"growthCheck"}
                  data-plasmic-override={overrides.growthCheck}
                  className={classNames("__wab_instance", sty.growthCheck)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "growthCheck",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "growthCheck",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  data-plasmic-name={"title11"}
                  data-plasmic-override={overrides.title11}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title11
                  )}
                >
                  {"Growth Plan ($89/month) - Process up to $30,000/month"}
                </div>
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must select a plan before submitting your application"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"submitButton"}
                data-plasmic-override={overrides.submitButton}
                className={classNames(projectcss.all, sty.submitButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ansr9
                  )}
                >
                  {"Submit Application"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "vertStack",
    "title12",
    "title13",
    "link",
    "freeCheck",
    "title8",
    "starterCheck",
    "title9",
    "premiumCheck",
    "title10",
    "growthCheck",
    "title11",
    "errorText",
    "submitButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  vertStack: [
    "vertStack",
    "title12",
    "title13",
    "link",
    "freeCheck",
    "title8",
    "starterCheck",
    "title9",
    "premiumCheck",
    "title10",
    "growthCheck",
    "title11",
    "errorText",
    "submitButton"
  ],

  title12: ["title12"],
  title13: ["title13", "link"],
  link: ["link"],
  freeCheck: ["freeCheck"],
  title8: ["title8"],
  starterCheck: ["starterCheck"],
  title9: ["title9"],
  premiumCheck: ["premiumCheck"],
  title10: ["title10"],
  growthCheck: ["growthCheck"],
  title11: ["title11"],
  errorText: ["errorText"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingReviewBiz__ArgProps,
          internalVariantPropNames: PlasmicOnboardingReviewBiz__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingReviewBiz__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingReviewBiz";
  } else {
    func.displayName = `PlasmicOnboardingReviewBiz.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingReviewBiz = Object.assign(
  // Top-level PlasmicOnboardingReviewBiz renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    vertStack: makeNodeComponent("vertStack"),
    title12: makeNodeComponent("title12"),
    title13: makeNodeComponent("title13"),
    link: makeNodeComponent("link"),
    freeCheck: makeNodeComponent("freeCheck"),
    title8: makeNodeComponent("title8"),
    starterCheck: makeNodeComponent("starterCheck"),
    title9: makeNodeComponent("title9"),
    premiumCheck: makeNodeComponent("premiumCheck"),
    title10: makeNodeComponent("title10"),
    growthCheck: makeNodeComponent("growthCheck"),
    title11: makeNodeComponent("title11"),
    errorText: makeNodeComponent("errorText"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicOnboardingReviewBiz
    internalVariantProps: PlasmicOnboardingReviewBiz__VariantProps,
    internalArgProps: PlasmicOnboardingReviewBiz__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingReviewBiz;
/* prettier-ignore-end */
